export const WORK_TYPE = {
  DEFAULT: '',
  SLEEPOVER: 'sleepover',
  NON_WORKED: 'non_worked',
};

export const NON_WORKED_WORK_TYPES = [WORK_TYPE.NON_WORKED, WORK_TYPE.SLEEPOVER];

// Shifts in these areas never count towards regular working hours.
export function isNonWorkedWorkType(workType) {
  return NON_WORKED_WORK_TYPES.includes(workType);
}
